const LIST_COLOR = {
    grey: '#778899',
    black: '#000000',
    pink: '#ff6b81',
    red: '#ff0000',
    blue: '#0000cd',
    green: '#32cd32',
    orange: '#ff4500',
    violet: '#800080',
    brown: '#cd853f',
    redBrick: '#9f0000'
};

const ListTicketKnowledgeConstant = {
    EXT_FILE_PAGE_KNOWLEDGE: {
        DISPLAY: 'page',
        LIST: [],
        COLOR_DISPLAY: LIST_COLOR.redBrick
    },
    EXT_FILE_OTHER: {
        DISPLAY: 'others',
        LIST: ['others'],
        COLOR_DISPLAY: LIST_COLOR.black
    },
    LIST_EXT_FILE: [
        {
            DISPLAY: 'txt',
            LIST: ['txt'],
            COLOR_DISPLAY: LIST_COLOR.grey
        },
        {
            DISPLAY: 'zip',
            LIST: ['zip'],
            COLOR_DISPLAY: LIST_COLOR.brown
        },
        {
            DISPLAY: 'pdf',
            LIST: ['pdf'],
            COLOR_DISPLAY: LIST_COLOR.red
        },
        {
            DISPLAY: 'html',
            LIST: ['html', 'htm'],
            COLOR_DISPLAY: LIST_COLOR.black
        },
        {
            DISPLAY: 'image',
            LIST: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'tif', 'tiff', 'webp'],
            COLOR_DISPLAY: LIST_COLOR.pink
        },
        {
            DISPLAY: 'doc',
            LIST: ['doc', 'docx', 'docm'],
            COLOR_DISPLAY: LIST_COLOR.blue
        },
        {
            DISPLAY: 'xls',
            LIST: ['xls', 'xlsx', 'xlsm'],
            COLOR_DISPLAY: LIST_COLOR.green
        },
        {
            DISPLAY: 'ppt',
            LIST: ['ppt', 'pptx', 'pptm'],
            COLOR_DISPLAY: LIST_COLOR.orange
        },
        {
            DISPLAY: 'video',
            LIST: ['mov', 'avi', 'mpeg', 'mp4', 'wmv', 'flv'],
            COLOR_DISPLAY: LIST_COLOR.violet
        },
        {
            DISPLAY: 'audio',
            LIST: ['wav', 'm4a', 'm4p', 'dsf', 'flac', 'mqa', 'mp3'],
            COLOR_DISPLAY: LIST_COLOR.black
        },
        {
            DISPLAY: 'AutoCAD',
            LIST: ['dxf', 'dwg', 'igs'],
            COLOR_DISPLAY: LIST_COLOR.black
        }
    ]
};

export default ListTicketKnowledgeConstant;
